// Size tokens that appear AFTER the colour number in a SKU (CAR-BPK21-LARGE-NAV).
// Sizes that appear before it (BOT-LAR01-BLA, EVETOT-NAU-LAR53-MRNE) are already part
// of the base prefix. Mapped to a canonical label so alternate spellings of the same
// size (LAR / LRG / LGE / LARGE) land in one group instead of forking it.
const SIZE_TOKENS = {
  LARGE: 'LARGE', LAR: 'LARGE', LRG: 'LARGE', LGE: 'LARGE',
  SMALL: 'SMALL', SML: 'SMALL',
  MEDIUM: 'MEDIUM', MED: 'MEDIUM',
  MINI: 'MINI', MAX: 'MAX', XL: 'XL',
};

// Single letters are ambiguous against colour codes, so they only count as a size
// when they are the SKU's final segment (SBAG01-BERLIN-L, SLG-WLT01-BLA-S).
const SHORT_SIZE_TOKENS = { L: 'LARGE', S: 'SMALL', M: 'MEDIUM' };

/**
 * Derive a product grouping key from a SKU: the family prefix plus its canonical size,
 * so sizes that carry a different landed cost aren't averaged together.
 * @param {string} sku - e.g. "CAR-BPK21-LARGE-NAV"
 * @returns {string} the group key, e.g. "CAR-BPK LARGE" (the SKU itself if unparseable)
 */
export const productOf = (sku) => {
  const m = /^([A-Za-z0-9-]*?[A-Za-z])(\d{2,})(.*)/.exec(sku || '');
  if (!m) return sku || '—';
  const base = m[1].replace(/-$/, '');
  const rest = m[3].split('-').filter(Boolean).map((t) => t.toUpperCase());
  const last = rest[rest.length - 1];
  const size = rest.map((t) => SIZE_TOKENS[t]).find(Boolean) || SHORT_SIZE_TOKENS[last];
  return size ? `${base} ${size}` : base;
};
